import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Status',
      fields: {
        delivery_visible: {
          label: 'Bezorging zichtbaar',
        },
        has_delivery: {
          label: 'Bezorging',
        },
        delivery_enabled: {
          label: 'Bezorging live',
        },
      },
    },
    delivery_mode: {
      title: 'Bezorgmodus',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Eigen bezorgdienst restaurant',
            [DeliveryMode.External]: 'Externe bezorgdienst ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Ophaalnotitie bezorger',
          placeholder: 'Nuttige ophaalinformatie voor de bezorger (bijv. hoe de ingang te vinden, etc.)',
        },
        instant_print_enabled: {
          label: 'Ticket afdrukken zonder te wachten op bezorger',
        },
        provider_not_connected: {
          wolt_drive: 'Nog niet verbonden: dit restaurant heeft geen geldig Wolt vestigings-ID.',
          connects_on_external:
            '{{provider}} wordt verbonden zodra de bezorgmodus is ingesteld op externe bezorgers en opgeslagen.',
          not_connected_yet:
            '{{provider}} is nog niet verbonden voor dit restaurant. Als dit niet verandert, neem dan contact op met support.',
        },
      },
    },
    scheduled_orders: {
      title: 'Geplande bestellingen',
      fields: {
        has_scheduled_orders: {
          label: 'Kunnen klanten vooruitbestellen voor een bepaalde tijd?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Minimale tijd (minuten) vooruit voor het inplannen van <strong>bezorg</strong>bestellingen',
          placeholder: '60',
          validation_name: 'Minimale inplantijd bezorging',
          external_hint: 'Bij externe bezorging moet dit minimaal {{minutes}} minuten (2 uur) zijn. ',
        },
        last_order_gap_delivery: {
          label: 'Laatste bestelmoment voor <strong>bezorging</strong> (minuten vóór sluitingstijd)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Bezorginformatie',
      fields: {
        average_order_delivery_time_min: {
          label: 'Bezorgtijd',
          placeholder: 'Tijd in minuten',
        },
        average_order_delivery_time_max: {
          label: 'tot',
          placeholder: 'Optioneel',
        },
      },
    },
    delivery_zones: {
      title: 'Bezorgzones',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    at_least_one_order_method_required:
      'Minimaal 1 bestelmethode (gepland of direct) moet ingeschakeld zijn. Je kunt niet beide uitschakelen.',
  },
};
